
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { toast } from 'sonner';
import { createDealerReport } from '@/services/dealerReports/dealerReportRpcService';
import { ReportType, REPORT_TYPE_LABELS } from '@/types/dealerReport';
import { useAuth } from '@/hooks/useAuth';
import { useState } from 'react';

const reportSchema = z.object({
  report_type: z.custom<ReportType>((val) => Object.keys(REPORT_TYPE_LABELS).includes(val as string), {
    message: "Seleziona un tipo di segnalazione valido.",
  }),
  description: z.string().max(1000, "La descrizione non può superare i 1000 caratteri.").optional(),
});

type ReportFormValues = z.infer<typeof reportSchema>;

interface UseDealerReportProps {
  dealerId: string;
  onSuccess?: () => void;
}

export function useDealerReport({ dealerId, onSuccess }: UseDealerReportProps) {
  const { isAuthenticated } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm<ReportFormValues>({
    resolver: zodResolver(reportSchema),
    defaultValues: {
      description: '',
    },
  });

  const onSubmit = form.handleSubmit(async (values) => {
    if (!isAuthenticated) {
      toast.error('Devi effettuare l\'accesso per inviare una segnalazione.');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      await createDealerReport({
        dealer_id: dealerId,
        report_type: values.report_type,
        description: values.description,
      });
      toast.success('Segnalazione inviata con successo. Grazie per il tuo contributo!');
      form.reset();
      onSuccess?.();
    } catch (error: any) {
      console.error('Failed to submit report:', error);
      toast.error(error.message || 'Si è verificato un errore durante l\'invio della segnalazione.');
    } finally {
      setIsSubmitting(false);
    }
  });

  return { form, onSubmit, isSubmitting };
}
